import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import JoinAccepted from './JoinAccepted';
import JoinError from './JoinError';
import { joinUrl } from '../../providers/EnvContextProvider';

// Server: GET /auth/join-by-invite/{joinCode}
export default function Join() {
  const isMountedRef = useRef(true);
  const [fetchingInProgress, setFetchingInProgress] = useState(false);

  const [joinData, setJoinData] = useState(null);
  const [errorData, setErrorData] = useState(null);
    
  const {jcode} = useParams();

  
  useEffect(()=>{
    const claimInvitation = () => {
      if (!fetchingInProgress) {
        console.log('[Join claimInvitation] Start.');
        setFetchingInProgress(true);
        fetch(joinUrl(jcode), {
          method: 'get',
          headers: {
           'Content-Type': 'application/json'
          }
        })
        .then(response => {        
          if (response.ok) {
            response
              .json()
              .then(joinData => setJoinData(joinData));
          }
          else {
            console.error('[Join claimInvitation] Response Error [status: %s] [error: %s]', response.status, response.statusText);
            response.json().then(errorData => {
              console.log('Error Data: %s', JSON.stringify(errorData));
              setErrorData(errorData);
            });
          }
        })
        .catch(jsonError => {
          console.error('[Join claimInvitation] Unexpected Error: %s', JSON.stringify(jsonError));
          setErrorData({      
            title: 'Sorry, Unable to access your invitation details', 
            note: 'It might be a bug! or unexpected demand overload at the moment.',
            blockers: [],
            supportOptions: ["Email: HelpDesk@kiponos.io"],
            userActions: ["Please click your invitation link again in a few seconds", "Ask for new invitation link", "Email our HeldDesk this data: %s"+JSON.stringify(jsonError)],
            ourActions: ["Our HelpDesk is automatically notified on any error, however, since this erorr is unexpected and might be due to a bug, we can not guarantee our auto-notifcation also worked so we suggest you email us the error"],
            progressOptions: [],
          });    
        })
        .finally(()=>{
          setFetchingInProgress(false);
          console.log('[Join claimInvitation] End.');
        });
      } else {
        console.log('Fetch already in progress. skipped.');
      }
    }

    if (isMountedRef.current) {
      claimInvitation();
    }

    return () => {
      isMountedRef.current = false;
    }
  }, [fetchingInProgress, jcode]);

  return (
    <div className='joinWrapper'>
      <div className='joinContainer'>
        {/* TODO: FixMe: BOTH shows!  both accepted and error show together. separate them please!  */}
        {joinData && <JoinAccepted joinData={joinData} joinCode={jcode}/> }
        {errorData && <JoinError errorData={errorData} /> }
      </div>
    </div>
  )
}
